module.exports = "/packs/images/svg/accessibility/adapted_wheelchair~91991c237087145bfaae660b97907cd5.svg";